import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ReportIssueDataType } from '../../../models/dashboard/driver-list/report-issue';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useReportIssue = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onReportIssueError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while reporting the issue.',
    );
  };

  const onReportIssueSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Issue reported successfully.');
  };

  const reportIssue = (data: ReportIssueDataType, conflictId: string) => {
    const url: HttpConfig = {
      url: `api/v1/company/hiring-conflicts/${conflictId}/report-issue`,
      method: 'post',
      data: data,
    };
    request(url, onReportIssueSuccess, setLoading, onReportIssueError);
  };

  return { reportIssue, loading };
};

export default useReportIssue;
